import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/header/Header';
import { Footer } from '../components/footer/Footer';
import { AppDownloadModal } from '../components/common/AppDownloadModal';
import { CLUBS_DATA } from '../data/clubsData';
import { FaUsers, FaStar, FaSearch, FaArrowLeft, FaDownload } from 'react-icons/fa';
import { SEOHead } from '../components/common/SEOHead';
import './ClubsPage.css';

export const ClubsPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTag, setSelectedTag] = useState('All');
  const [isAppModalOpen, setIsAppModalOpen] = useState(false);
  const [activeClubName, setActiveClubName] = useState('');
  const navigate = useNavigate();

  const tags = ['All', 'Fine Dining', 'Vegan', 'Mediterranean', 'Quick', 'Baking', 'Asian', 'BBQ', 'Keto'];

  const filteredClubs = CLUBS_DATA.filter((club) => {
    const matchesSearch = club.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          club.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          club.slogan.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesTag = selectedTag === 'All' || club.tags.includes(selectedTag);
    return matchesSearch && matchesTag;
  });

  const handleJoinClub = (clubName) => {
    setActiveClubName(`Join "${clubName}" on App`);
    setIsAppModalOpen(true);
  };

  return (
    <div className="clubs-page-container">
      <SEOHead
        title="Recipe Clubs & Cooking Communities — ShareRecipe"
        description="Explore thriving culinary communities, secret family recipes, and connect with passionate foodies on ShareRecipe."
        canonicalUrl="https://sharecipe.app/clubs"
      />
      <Header />

      <main className="clubs-main">
        <div className="clubs-hero">
          <button className="back-home-btn" onClick={() => navigate('/')}>
            <FaArrowLeft /> Back to Home
          </button>
          <h1>Discover 10 Public Recipe Clubs</h1>
          <p>Explore thriving culinary communities, secret recipes, and connect with passionate foodies without registration!</p>

          <div className="clubs-search-bar">
            <FaSearch className="search-icon" />
            <input 
              type="text" 
              placeholder="Search recipe clubs by name, cuisine, or tag..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="clubs-tags-filter">
            {tags.map((tag) => (
              <button
                key={tag}
                className={`tag-btn ${selectedTag === tag ? 'active' : ''}`}
                onClick={() => setSelectedTag(tag)}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="clubs-grid">
          {filteredClubs.map((club) => (
            <div key={club.id} className="club-card">
              <div className="club-card-image">
                <img src={club.image} alt={club.name} />
                <span className="club-members-badge">
                  <FaUsers /> {club.membersCount} Members
                </span>
              </div>
              <div className="club-card-content">
                <div className="club-rating">
                  <FaStar className="star-icon" /> {club.rating}
                </div>
                <h3>{club.name}</h3>
                <p className="club-slogan">"{club.slogan}"</p>
                <p className="club-desc">{club.description}</p>
                
                <div className="club-tags">
                  {club.tags.map((t) => (
                    <span key={t} className="club-tag-pill">{t}</span>
                  ))}
                </div>

                <div className="club-card-actions">
                  <button 
                    className="join-club-btn"
                    onClick={() => handleJoinClub(club.name)}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                  >
                    <FaDownload /> Join Club on App
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      <Footer />

      <AppDownloadModal 
        isOpen={isAppModalOpen}
        onClose={() => setIsAppModalOpen(false)}
        title={activeClubName || "Join Recipe Club on App"}
      />
    </div>
  );
};
